define('TescoMobile_Customer/js/view/account/dashboard/nudge/eligible-for-free-upgrade',['uiComponent', 'ko', 'Magento_Customer/js/customer-data'], function (Component, ko, customerData) {
  "use strict";

  return Component.extend({
    defaults: {
      template: 'TescoMobile_Customer/account/dashboard/nudge/eligible-for-free-upgrade',
      isEligibleForFreeUpgrade: false,
      content: null,
      firstname: null
    },
    initObservable: function () {
      this._super();
      this.observe(['isEligibleForFreeUpgrade', 'content', 'firstname']);
      return this;
    },
    initialize: function () {
      this._super();
      const customer = customerData.get('customer');
      this.customerDataUpdate(customer());
      customerData.get('customer').subscribe(this.customerDataUpdate, this);
    },
    customerDataUpdate: function (data) {
      this.isEligibleForFreeUpgrade(data === null || data === void 0 ? void 0 : data.is_eligible_for_free_upgrade);
      this.firstname(data === null || data === void 0 ? void 0 : data.firstname);
    }
  });
});

